import { LoadState } from "../../constants/enums";

import {
	IGoogleReviewState,
	IGoogleReview,
	IReviewResponseConfig,
} from "./review.types";

export const defaultGoogleReview: IGoogleReview = {
	google_reviews_id: 0,
	google_reviews_unique_id: 0,
	google_reviews_uuid: "",
	author_name: "",
	review_id: "",
	rating: "ONE",
	location_name: "",
	review_text: "",
	create_time: new Date().toISOString(),
	status: "ACTIVE",
	created_by_uuid: null,
	created_by_name: null,
	modified_by_uuid: null,
	modified_by_name: null,
	create_ts: null,
	insert_ts: new Date().toISOString(),
};

export const defaultReviewResponseConfig: IReviewResponseConfig = {
	text: "",
	stars: 0,
	responseStyle: "casual",
	includeEmojis: false,
	responseLength: 0,
	keywords: [],
	avoidKeywords: [],
	referToSelfAsIndividual: false,
	mentionNames: false,
	name: "",
};

export const defaultGoogleReviewState: IGoogleReviewState = {
	list: {
		data: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	review: {
		data: defaultReviewResponseConfig,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
